import { Box, Divider, Grid, Typography } from "@mui/material";
import StyledModal from "../../components/drawers/StyledModal";
import TransactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import useInputObject from "../../hooks/useInputObject";
import { useMemo } from "react";
import { formatNumber } from "../../utils/utils";

const TransactionModal = (props) => {
  const {
    mode,
    transactions,
    insert,
    open,
    setOpen,
    paging,
    commodityOwners,
    buyers,
  } = props;
  async function insertTransaction(transaction) {
    insert(transaction);
  }

  const selectTransaction = useInputObject(null);

  const totalAmount = useMemo(
    () =>
      transactions.Value.map((item) => parseInt(item.amount) || 0).reduce(
        (prevValue, currValue) => prevValue + currValue,
        0
      ),
    [transactions.Value]
  );

  return (
    <StyledModal open={open} setOpen={setOpen}>
      <Box display="flex" sx={{ padding: 1, width: 1700, height: 750 }}>
        <Grid container display="flex" flexDirection="row">
          <Grid item display="flex" flexDirection="column" xs={3.5}>
            <TransactionForm
              mode={mode}
              insert={insert}
              insertTransaction={insertTransaction}
              closeModal={() => setOpen(false)}
              commodityOwners={commodityOwners}
              buyers={buyers}
              selectTransaction={selectTransaction}
            />
          </Grid>

          <Divider orientation="vertical" sx={{ p: 1 }} />
          {/* History */}

          <Grid
            item
            display="flex"
            flexDirection="column"
            xs={8.3}
            sx={{ px: 1 }}
          >
            <Grid container>
              <Grid xs={9}>
                <Typography variant="h6" textAlign="left" mb={3}>
                  履歴
                </Typography>
              </Grid>
              <Grid xs={3}>
                <Typography variant="h6" textAlign="right" mb={3}>
                  合計金額：
                  {formatNumber(totalAmount)}
                </Typography>
              </Grid>
            </Grid>
            {/* <HistoryTransactionItem deposits={transactions} /> */}
            <TransactionTable
              mode={mode}
              transactions={transactions}
              paging={paging}
              selectTransaction={selectTransaction}
            />
          </Grid>
        </Grid>
      </Box>
    </StyledModal>
  );
};
export default TransactionModal;
